import { createContext, useContext } from "react";

// Mui Select needs to know the shadow dom container so it knows where to anchor the dropdown.
// Once we migrate to iframe, no need for this context.
// https://www.answeroverflow.com/m/1099774541141659710
export const ShadowDomContext = createContext<HTMLElement | null>(null);

export const useShadowContainer = () => useContext(ShadowDomContext);
